









































































import Vue from 'vue'
import { mapState } from 'vuex'

import IconSynchronizerFolder from '@/components/icons/icon-synchronizer-folder.vue'

import VueContext from 'vue-context'
import 'vue-context/src/sass/vue-context.scss'
import { View, ViewShort } from '@/types/view'

// import NavViewLink from './nav-view-link.vue'
// import NavViewGroup from './nav-view-group.vue'

export default Vue.extend({
  name: 'NavDevice',
  components: {
    IconSynchronizerFolder,
    VueContext,
    // NavViewGroup,
    // NavViewLink,
  },
  data() {
    return {
      // eslint-disable-next-line
      contextTarget: null as any,
      selectedView: {} as ViewShort,
      expand: false,
    }
  },
  computed: {
    ...mapState('view', ['items']),
  },
  methods: {
    // eslint-disable-next-line
    handleViewContextMenu($event: any, v: ViewShort) {
      console.log($event.currentTarget)
      this.selectedView = v
      // eslint-disable-next-line
      ;(this as any).$refs.viewContextMenu.open($event)
      this.contextTarget = $event.currentTarget
    },

    async handleAddNewView() {
      const { id } = await this.$store.dispatch('view/createEmptyView')
      this.$router.push({ path: `/design/view/${id}` })
    },
    async handleAddNewGroup() {
      const { id } = await this.$store.dispatch('view/createNewGroup')
      this.$router.push({ path: `/design/view/${id}` })
    },

    async handleDeleteView() {
      // eslint-disable-next-line
      ;(this as any).$refs.deleteViewDialog.show()
    },

    async patchView(view: View) {
      const { uid, slug } = await this.$store.dispatch('view/patch', {
        id: view.id,
        view,
      })
      if (
        this.$route.name === 'EditView' &&
        this.$route.params.uid &&
        this.$route.params.uid === uid
      ) {
        this.$router.push({ name: 'EditView', params: { uid, slug } })
      }
      this.contextTarget.classList.remove('rename')
    },

    async deleteView() {
      await this.$store.dispatch('view/delete', this.selectedView)
      // await this.$store.dispatch('view/get', this.selectedView)

      if (this.$route.params.uid === this.selectedView.uid) {
        this.$router.push({ path: '/design' })
      }
    },
  },
})
